import Reflux from 'reflux';

const ArchiveLicenseActions = Reflux.createActions({
  getLicenseStatus: { asyncResult: true },
});

export default ArchiveLicenseActions;



// WEBPACK FOOTER //
// ./src/web/ArchiveLicenseActions.jsx